/**
 * Internal dependencies
 */
import { createAction } from '../action-creators';
import { RootState } from '../types';
import { SET_HEADER_HEIGHT } from '../actionTypes';

export const setHeaderHeight =
	createAction<RootState['ui']['headerHeight']>(SET_HEADER_HEIGHT);
